import { useIntl } from 'react-intl';
import { ActionStatus } from '../../gql/graphql';

export const useActionStatusOptions = (): {
	statusOptions: {
		value: ActionStatus;
		text: string;
		color: string;
	}[];
} => {
	const intl = useIntl();

	return {
		statusOptions: [
			{
				value: 'open',
				text: intl.formatMessage({ id: 'action.status.open' }),
				color: '#FAAD14',
			},
			{
				value: 'approved',
				text: intl.formatMessage({ id: 'action.status.approved' }),
				color: '#52C41A',
			},
			{
				value: 'rejected',
				text: intl.formatMessage({ id: 'action.status.rejected' }),
				color: '#FF4D4F',
			},
			{
				value: 'resolved',
				text: intl.formatMessage({ id: 'action.status.resolved' }),
				color: '#52C41A',
			},
		],
	};
};
